import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { useEffect } from "react";
import SelectLine from "../ui/selectLine";
import InputLine from "../ui/inputLine";
import WarningBox from "../ui/warningBox";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";
import DateLine from "../ui/dateLine";
import TextAreaLine from "../ui/textAreaLine";
const MAX_CHARS = 100;
const Step2Form = ({
                       formik,
                       countries,
                       counties,
                       organization,
                       handleCountyChange,
                       language,
    error
                   }) => {

    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
    } = formik;



    const {t} = useTranslation(PAGE_APPLICATIONS)

    useEffect(() => {
        setFieldValue("state", "");
    }, [language]);

    return (
        <Box
            sx={{
                mt: 6,
                display: "flex",
                alignItems: "flex-start",
                gap: 4,
                maxWidth: 1280,
            }}
        >

            <Box sx={{ width: 826, maxWidth: "100%" }}>
                <Typography
                    sx={{ fontWeight: 700, fontSize: 16, color: "#004B88", mb: 2 }}
                >
                    {t("General information")}
                </Typography>

                <Box sx={{maxWidth:"77%"}}>
                    <SelectLine
                        label={t("Country")}
                        name="country"
                        required
                        value={values.country}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        options={countries?.map(c => ({
                            value: c.Id,
                            label: language === 'el' ? c.NameEL : c.NameEN
                        })) ?? []}
                        error={touched.country && errors.country}
                        helperText={errors.country}

                    />
                    {language === 'el' &&
                        <InputLine
                        label={t("Organization name(in greek characters)")}
                        name="orgName"
                        required
                        value={values.orgName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!!organization}
                        error={touched.orgName && errors.orgName}
                        helperText={errors.orgName}
                    />}
                    <InputLine
                        label={language === 'el'?t("Organization name(in latin characters)"):t('Organization name')}
                        name="orgName_en"
                        required
                        value={values.orgName_en}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!!organization}
                        error={touched.orgName_en && errors.orgName_en}
                        helperText={errors.orgName_en}
                    />
                    {/*<InputLine*/}
                    {/*    label={t("Organization mission")}*/}
                    {/*    name="orgMission"*/}
                    {/*    required*/}
                    {/*    multiline*/}
                    {/*    rows={4}*/}
                    {/*    value={values.orgMission}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    onBlur={handleBlur}*/}
                    {/*    error={touched.orgMission && errors.orgMission}*/}
                    {/*    helperText={errors.orgMission}*/}
                    {/*/>*/}
                    {/*<InputLine*/}
                    {/*    label={t("Authority under which nonprofit status is registered")}*/}
                    {/*    name="orgRegisteredAsPer"*/}
                    {/*    required*/}
                    {/*    value={values.orgRegisteredAsPer}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    onBlur={handleBlur}*/}
                    {/*    error={touched.orgRegisteredAsPer && errors.orgRegisteredAsPer}*/}
                    {/*    helperText={errors.orgRegisteredAsPer}*/}
                    {/*/>*/}
                    {/*<DateLine*/}
                    {/*    label={t("Date established")}*/}
                    {/*    name="orgDateEstablished"*/}
                    {/*    required*/}
                    {/*    value={values.orgDateEstablished}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    onBlur={(e) => {*/}
                    {/*        e.target.name = "orgDateEstablished";*/}
                    {/*        handleBlur(e);*/}
                    {/*    }}*/}
                    {/*    error={touched.orgDateEstablished && errors.orgDateEstablished}*/}
                    {/*    helperText={errors.orgDateEstablished}*/}
                    {/*/>*/}


                    {/*<InputLine*/}
                    {/*    label={t("Fiscal sponsor (if applicable)")}*/}
                    {/*    name="orgFiscalSponsor"*/}
                    {/*    value={values.orgFiscalSponsor}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    onBlur={handleBlur}*/}
                    {/*/>*/}
                    <TextAreaLine
                        label={t("How did you learn for us?")}
                        name="learnForUs"
                        rows={2}
                        value={values.learnForUs}
                        onChange={(e) => {
                            if (e.target.value.length <= MAX_CHARS)
                                setFieldValue("learnForUs", e.target.value);
                        }}
                        onBlur={handleBlur}
                        error={touched.learnForUs && errors.learnForUs}
                        helperText={errors.learnForUs}
                    />
                    <Typography sx={{ fontSize: 12, color: "#666", mt: 0.3 }}>
                        {values.learnForUs.length}/{MAX_CHARS}
                    </Typography>
                </Box>

                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 16,
                        color: "#004B88",
                        mt: 5,
                        mb: 2,
                    }}
                >
                    {t("Address & contact information")}
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 4,
                        maxWidth: 800,
                    }}
                >
                    <InputLine
                        label={t("Address Line 1")}
                        name="address1"
                        required
                        value={values.address1}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!!organization}
                        error={touched.address1 && errors.address1}
                        helperText={errors.address1}
                    />

                    <InputLine
                        label={t("Address Line 2")}
                        name="address2"
                        value={values.address2}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!!organization}
                    />

                    <InputLine
                        label={t("City")}
                        name="city"
                        required
                        value={values.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!!organization}
                        error={touched.city && errors.city}
                        helperText={errors.city}
                    />

                    {language === 'el'
                        ? <SelectLine
                        label={t("State/Prefecture")}
                        name="state"
                        required
                        value={values.state}
                        // onChange={(e) => {
                        //     handleCountyChange(e.target.value);
                        //     handleChange(e);
                        // }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        options={counties.map(c => ({
                            value: c.Id,
                            label: language === "el" ? c.NameEL : c.NameEN
                        }))}
                        error={touched.state && errors.state}
                        helperText={errors.state}

                    />:
                        <InputLine
                            label={t("State/Prefecture")}
                            name="state"
                            required
                            value={values.state}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.state && errors.state}
                            helperText={errors.state}
                        />
                    }
                    <InputLine
                        label={t("Zip code")}
                        name="zip"
                        required
                        value={values.zip}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!!organization}
                        error={touched.zip && errors.zip}
                        helperText={errors.zip}
                    />

                    <InputLine
                        label={t("Office phone")}
                        name="phone"
                        required
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!!organization}
                        error={touched.phone && errors.phone}
                        helperText={errors.phone}
                    />
                </Box>
                <Box sx={{maxWidth:"77%"}}>
                    <InputLine
                        label={t("Email")}
                        name="email"
                        required
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!!organization}
                        error={touched.email && errors.email}
                        helperText={errors.email}
                    />
                </Box>

                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 16,
                        color: "#004B88",
                        mt: 5,
                        mb: 2,
                    }}
                >
                    {t("Organization website & social media(if applicable)")}
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 4,
                        maxWidth: 800,
                    }}
                >
                    <InputLine label={t("Website")} name="website" value={values.website} onChange={handleChange} onBlur={handleBlur} />

                    <InputLine label={t("Facebook")} name="facebook" value={values.facebook} onChange={handleChange} onBlur={handleBlur} />

                    <InputLine label={t("X")} name="x" value={values.x} onChange={handleChange} onBlur={handleBlur} />

                    <InputLine label={t("Instagram")} name="instagram" value={values.instagram} onChange={handleChange} onBlur={handleBlur} />

                    <InputLine label={t("Other social network")} name="otherSocial" value={values.otherSocial} onChange={handleChange} onBlur={handleBlur} />
                </Box>
                <Box sx={{ mt: 4 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={values.authorized}
                                onChange={(e) =>
                                    setFieldValue("authorized", e.target.checked)
                                }
                                sx={{
                                    color: "#004B88",
                                    "&.Mui-checked": { color: "#004B88" },
                                }}
                            />
                        }
                        label={t("I affirm that I am authorized")}
                        sx={{ color: "#004B88" }}
                    />
                    {touched.authorized && errors.authorized && (
                        <Typography sx={{ color: "#d32f2f", fontSize: 14 }}>
                            {errors.authorized}
                        </Typography>
                    )}
                </Box>
            </Box>

            <Box sx={{ display: { xs: "none", md: "block" } }}>
                <WarningBox />
            </Box>
        </Box>
    );
};

export default Step2Form;
